import styled from '@emotion/styled';
import { Dialog } from '@biome-design-system/ui/Dialog';
import { fromTheme } from '@kyruus/ui-theme';

export const AppointmentInfoContainer = styled.div`
  padding-bottom: ${fromTheme('spacing_medium')};

  h4 {
    margin-bottom: ${fromTheme('spacing_medium')};
  }
`;

export const Link = styled('a')`
  color: ${fromTheme('color_link')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const PleaseCallContainer = styled.div`
  div:not(:last-child) {
    margin-bottom: ${fromTheme('spacing_small')};
  }
`;

export const AvailabilityModalHeader = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${fromTheme('spacing_medium')};
  height: ${fromTheme('spacing_xxxlarge')};
`;

export const AvailabilityDialog = styled(Dialog)`
  & .MuiDialog-container {
    align-items: flex-start;
  }
`;
